import { FunctionComponent, useCallback } from "react";

import { useCurrentUserContext } from "../contexts/CurrentUserContext";
import {
  OrganizationEngagementFlagsContext,
  UpdateEngagementFlagsInput,
} from "../contexts/OrganizationEngagementFlagsContext";
import { trpc } from "../helpers/trpc";

export const OrganizationEngagementFlagsProvider: FunctionComponent<React.PropsWithChildren> = ({ children }) => {
  const { isOrganization } = useCurrentUserContext();
  const {
    data,
    isLoading: loading,
    refetch,
  } = trpc.getOrganizationEngagementFlags.useQuery(undefined, {
    enabled: isOrganization,
    staleTime: 0,
    refetchOnMount: true,
  });

  const { mutateAsync: execUpdateOrganizationEngagementFlags } = trpc.updateOrganizationEngagementFlags.useMutation();

  const updateFlags = useCallback(
    async (flags: UpdateEngagementFlagsInput) => {
      if (data?.id) {
        await execUpdateOrganizationEngagementFlags({
          id: data.id,
          ...flags,
        });
        await refetch();
      }
    },
    [data?.id, execUpdateOrganizationEngagementFlags, refetch]
  );

  return (
    <OrganizationEngagementFlagsContext.Provider value={{ flags: data || undefined, loading, updateFlags }}>
      {children}
    </OrganizationEngagementFlagsContext.Provider>
  );
};
